// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: light;
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
    "Segoe UI", sans-serif;
  color: #18181b;
  background: #ffffff;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  position: relative;
  min-width: 320px;
  min-height: 100vh;
  margin: 0;
  overflow-x: hidden;
  background: #ffffff;
}

body::before {
  content: none;
}

.background-glow {
  display: none;
}

.background-glow--one {
  top: -19rem;
  left: -12rem;
  background: #00d9ff;
}

.background-glow--two {
  right: -15rem;
  bottom: 2rem;
  background: #3669ff;
}

.site-shell {
  width: min(100% - 2rem, 74rem);
  margin-inline: auto;
}

.hero {
  display: grid;
  min-height: clamp(16rem, 38vh, 24rem);
  place-items: center;
  padding: 2rem 0 3rem;
}

.brand-lockup {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-halo {
  position: relative;
  display: grid;
  width: min(70vw, 15rem);
  aspect-ratio: 1;
  place-items: center;
}

.logo-halo::before {
  content: none;
}

.studio-logo {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 1.25rem 1.75rem rgb(0 20 52 / 28%));
}

.brand-slogan {
  margin: 0.65rem 0 0;
  color: #3f3f46;
  font-family: "Orbitron", "Eurostile", "Bank Gothic", sans-serif;
  font-size: clamp(0.68rem, 1.5vw, 0.8rem);
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.08em;
  text-align: center;
  white-space: nowrap;
}

.games {
  border-top: 1px solid #e4e4e7;
  padding: 3rem 0 clamp(5rem, 10vw, 8rem);
}

.section-kicker {
  margin: 0 0 0.8rem;
  color: #087f9c;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-align: center;
  text-transform: uppercase;
}

h2 {
  margin: 0 0 clamp(2rem, 5vw, 4rem);
  font-family: "Orbitron", "Eurostile", "Bank Gothic", sans-serif;
  font-size: clamp(1.75rem, 4vw, 3.25rem);
  font-weight: 600;
  line-height: 1;
  letter-spacing: -0.045em;
  text-align: center;
  text-shadow: none;
}

.game-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(0.8rem, 2vw, 1.3rem);
}

.game-card {
  --card-accent: 56 214 255;
  position: relative;
  display: flex;
  min-height: clamp(12rem, 24vw, 18rem);
  overflow: hidden;
  align-items: flex-end;
  width: 100%;
  padding: clamp(1.1rem, 2.5vw, 1.6rem);
  border: 1px solid rgb(255 255 255 / 11%);
  border-radius: 1rem;
  isolation: isolate;
  background:
    linear-gradient(145deg, rgb(var(--card-accent) / 18%), transparent 42%),
    linear-gradient(to top, rgb(3 10 23 / 96%), rgb(9 23 43 / 34%)),
    #0c182a;
  box-shadow: 0 1.2rem 3rem rgb(0 0 0 / 18%);
  color: #eef8ff;
  cursor: pointer;
  font: inherit;
  text-align: left;
  text-decoration: none;
  transition:
    border-color 180ms ease,
    transform 180ms ease,
    box-shadow 180ms ease;
}

.game-card::before,
.game-card::after {
  position: absolute;
  z-index: -1;
  content: "";
}

.game-card::before {
  top: 18%;
  left: 50%;
  width: 46%;
  aspect-ratio: 1;
  border: 1px solid rgb(var(--card-accent) / 48%);
  transform: translateX(-50%) rotate(45deg);
  box-shadow:
    0 0 2rem rgb(var(--card-accent) / 20%),
    inset 0 0 2rem rgb(var(--card-accent) / 10%);
}

.game-card::after {
  inset: 0;
  background: linear-gradient(120deg, transparent 35%, rgb(255 255 255 / 5%), transparent 65%);
  transform: translateX(-100%);
  transition: transform 450ms ease;
}

.game-card:hover {
  border-color: rgb(var(--card-accent) / 55%);
  box-shadow: 0 1.8rem 4rem rgb(0 0 0 / 30%);
  transform: translateY(-0.35rem);
}

.game-card:hover::after {
  transform: translateX(100%);
}

.game-card:focus-visible {
  border-color: rgb(var(--card-accent) / 85%);
  outline: 3px solid rgb(var(--card-accent) / 38%);
  outline-offset: 3px;
}

.game-card--two,
.game-card--eight {
  --card-accent: 114 125 255;
}

.game-card--three,
.game-card--seven {
  --card-accent: 50 237 199;
}

.game-card--four,
.game-card--nine {
  --card-accent: 176 116 255;
}

.game-card--ten {
  --card-accent: 212 175 55;
}

.game-card--eleven {
  --card-accent: 72 184 255;
}

.game-card--twelve {
  --card-accent: 114 125 255;
}

.game-card--thirteen {
  --card-accent: 50 237 199;
}

.game-card--fourteen {
  --card-accent: 176 116 255;
}

.game-card--fifteen {
  --card-accent: 255 184 77;
}

.game-card--sixteen {
  --card-accent: 255 102 24;
}

.game-card--five {
  --card-accent: 255 184 77;
}

.game-card--six {
  --card-accent: 255 104 152;
}

.game-date {
  position: absolute;
  top: 1rem;
  right: 1.1rem;
  color: #d4af37;
  font-family: "Orbitron", monospace;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-shadow: 0 0 1rem rgb(212 175 55 / 30%);
}

.game-card__multiplayer {
  position: absolute;
  z-index: 2;
  top: clamp(0.65rem, 1.5vw, 0.9rem);
  left: clamp(0.7rem, 1.5vw, 1rem);
  width: clamp(6.25rem, 11vw, 7.75rem);
  aspect-ratio: 4.9 / 1;
  object-fit: cover;
  object-position: center;
  filter: drop-shadow(0 0.2rem 0.35rem rgb(0 0 0 / 55%));
  pointer-events: none;
}

.game-card__content {
  position: relative;
  z-index: 1;
}

.game-card--featured {
  align-items: stretch;
}

.game-card__content--featured {
  display: flex;
  min-height: 100%;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1.25rem;
  text-align: center;
}

.game-card__logo {
  display: block;
  width: 100%;
  height: clamp(6rem, 12vw, 8.75rem);
  object-fit: contain;
  filter: drop-shadow(0 0.75rem 1rem rgb(0 0 0 / 38%));
}

.game-card--ghosts .game-card__logo {
  width: min(72%, 10rem);
  height: clamp(7.5rem, 14vw, 10rem);
}

.game-card--small-town {
  --card-accent: 255 157 65;
  background:
    radial-gradient(circle at 50% 20%, rgb(255 204 88 / 23%), transparent 35%),
    linear-gradient(145deg, rgb(20 174 177 / 24%), transparent 48%),
    linear-gradient(to top, rgb(3 30 42 / 98%), rgb(14 71 80 / 78%)),
    #07333d;
}

.game-card--small-town .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--lazy-lunch-lady {
  --card-accent: 239 65 54;
  background:
    radial-gradient(circle at 50% 18%, rgb(255 193 69 / 22%), transparent 36%),
    linear-gradient(145deg, rgb(21 118 110 / 30%), transparent 50%),
    linear-gradient(to top, rgb(40 10 13 / 98%), rgb(8 55 58 / 82%)),
    #123f40;
}

.game-card--lazy-lunch-lady .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--bedbug-bash {
  --card-accent: 255 85 42;
  background:
    radial-gradient(circle at 50% 20%, rgb(255 205 50 / 24%), transparent 36%),
    linear-gradient(145deg, rgb(180 35 24 / 28%), transparent 50%),
    linear-gradient(to top, rgb(43 9 6 / 98%), rgb(91 28 15 / 82%)),
    #35100a;
}

.game-card--bedbug-bash .game-card__logo {
  height: clamp(7rem, 14vw, 10rem);
}

.game-card--poop-racer {
  --card-accent: 24 201 204;
  background:
    radial-gradient(circle at 50% 18%, rgb(249 218 38 / 20%), transparent 36%),
    linear-gradient(145deg, rgb(20 198 198 / 30%), transparent 50%),
    linear-gradient(to top, rgb(31 14 6 / 98%), rgb(5 61 66 / 86%)),
    #07383b;
}

.game-card--poop-racer .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--cafe-nervosa {
  --card-accent: 247 191 50;
  background:
    radial-gradient(circle at 50% 20%, rgb(23 178 176 / 24%), transparent 38%),
    linear-gradient(145deg, rgb(219 48 35 / 28%), transparent 52%),
    linear-gradient(to top, rgb(29 10 5 / 98%), rgb(77 27 13 / 84%)),
    #2c110b;
}

.game-card--cafe-nervosa .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--lost-tribes {
  background:
    radial-gradient(circle at 50% 18%, rgb(212 175 55 / 24%), transparent 38%),
    linear-gradient(145deg, rgb(14 75 105 / 34%), transparent 52%),
    linear-gradient(to top, rgb(12 8 4 / 98%), rgb(7 30 44 / 88%)),
    #071923;
}

.game-card--lost-tribes .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--frost-fighter {
  background:
    radial-gradient(circle at 50% 18%, rgb(137 255 101 / 19%), transparent 36%),
    linear-gradient(145deg, rgb(65 201 255 / 27%), transparent 50%),
    linear-gradient(to top, rgb(2 20 41 / 98%), rgb(5 50 79 / 86%)),
    #062943;
}

.game-card--frost-fighter .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--trash-or-treasure {
  --card-accent: 234 183 50;
  background:
    radial-gradient(circle at 50% 18%, rgb(255 211 67 / 24%), transparent 36%),
    linear-gradient(145deg, rgb(92 133 48 / 30%), transparent 50%),
    linear-gradient(to top, rgb(24 14 7 / 98%), rgb(48 60 26 / 86%)),
    #252714;
}

.game-card--trash-or-treasure .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--poison-pickle {
  --card-accent: 166 255 0;
  background:
    radial-gradient(circle at 50% 18%, rgb(172 255 47 / 25%), transparent 38%),
    linear-gradient(145deg, rgb(151 28 255 / 30%), transparent 52%),
    linear-gradient(to top, rgb(17 3 27 / 98%), rgb(27 49 8 / 88%)),
    #13051d;
}

.game-card--poison-pickle .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--c-suite-simulator {
  --card-accent: 32 211 170;
  background:
    radial-gradient(circle at 50% 18%, rgb(255 165 45 / 24%), transparent 38%),
    linear-gradient(145deg, rgb(13 154 151 / 32%), transparent 52%),
    linear-gradient(to top, rgb(21 8 4 / 98%), rgb(4 47 49 / 88%)),
    #062b2d;
}

.game-card--c-suite-simulator .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--escape-from-seattle {
  --card-accent: 189 54 32;
  background:
    radial-gradient(circle at 50% 18%, rgb(216 92 45 / 22%), transparent 38%),
    linear-gradient(145deg, rgb(73 83 60 / 28%), transparent 52%),
    linear-gradient(to top, rgb(10 8 7 / 98%), rgb(37 42 34 / 90%)),
    #12130f;
}

.game-card--escape-from-seattle .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--woke-trash-battle-chess {
  background:
    radial-gradient(circle at 50% 20%, rgb(255 102 24 / 26%), transparent 42%),
    linear-gradient(145deg, rgb(246 224 181 / 12%), transparent 52%),
    linear-gradient(to top, rgb(10 8 7 / 98%), rgb(34 23 17 / 90%)),
    #17110d;
}

.game-card--woke-trash-battle-chess .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--waifu-wants-waffles {
  --card-accent: 255 145 182;
  background:
    radial-gradient(circle at 50% 22%, rgb(255 183 93 / 24%), transparent 48%),
    linear-gradient(to top, #201019, #472737);
}

.game-card--communist-comrades {
  --card-accent: 207 84 245;
  background:
    radial-gradient(circle at 50% 22%, rgb(225 64 131 / 25%), transparent 48%),
    linear-gradient(to top, #1c0d20, #392039);
}

.game-card--witch-race-derby {
  --card-accent: 195 125 255;
  background:
    radial-gradient(circle at 50% 22%, rgb(255 202 88 / 22%), transparent 48%),
    linear-gradient(to top, #180d2c, #44265c);
}

.game-card--witch-race-derby .game-card__logo,
.game-card--waifu-wants-waffles .game-card__logo,
.game-card--communist-comrades .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--breeders {
  --card-accent: 167 224 116;
  background:
    radial-gradient(circle at 50% 22%, rgb(181 151 229 / 22%), transparent 48%),
    linear-gradient(to top, #101e18, #2b3e2d);
}

.game-card--breeders .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--sandwich-maker-puzzle {
  --card-accent: 255 190 83;
  background:
    radial-gradient(circle at 50% 22%, rgb(255 169 52 / 24%), transparent 48%),
    linear-gradient(to top, #211008, #4a2912);
}

.game-card--sandwich-maker-puzzle .game-card__logo {
  height: clamp(8rem, 15vw, 11rem);
}

.game-card--placeholder {
  background:
    linear-gradient(145deg, rgb(var(--card-accent) / 13%), transparent 48%),
    linear-gradient(to top, rgb(3 10 23 / 98%), rgb(18 31 50 / 72%)),
    #0c182a;
}

.game-card--placeholder::before {
  border-style: dashed;
  opacity: 0.55;
}

.game-card--placeholder .game-card__content {
  margin: auto 0;
}

.game-card h3 {
  margin: 0;
  font-family: "Orbitron", "Eurostile", sans-serif;
  font-size: clamp(0.9rem, 2vw, 1.1rem);
  font-weight: 600;
  letter-spacing: 0.04em;
}

.game-card p {
  margin: 0.4rem 0 0;
  color: rgb(211 238 249 / 62%);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}

.game-card p.game-card__subtitle {
  max-width: 29rem;
  margin-top: 0.8rem;
  color: rgb(238 248 255 / 78%);
  font-size: clamp(0.55rem, 1.1vw, 0.67rem);
  line-height: 1.5;
  letter-spacing: 0.07em;
  text-transform: none;
}

.modal-open {
  overflow: hidden;
}

.game-modal {
  width: min(92vw, 52rem);
  max-height: 92vh;
  overflow: auto;
  padding: 0;
  border: 0;
  border-radius: 1.25rem;
  background: #ffffff;
  box-shadow: 0 2rem 6rem rgb(0 0 0 / 38%);
}

.game-modal::backdrop {
  background: rgb(3 10 23 / 76%);
  backdrop-filter: blur(6px);
}

.game-modal__panel {
  position: relative;
  padding: clamp(1.25rem, 4vw, 2.5rem);
}

.game-modal__close {
  position: absolute;
  z-index: 1;
  top: 1rem;
  right: 1rem;
  display: grid;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border: 1px solid #d4d4d8;
  border-radius: 50%;
  place-items: center;
  background: #ffffff;
  color: #27272a;
  cursor: pointer;
  font-size: 1.65rem;
  line-height: 1;
}

.game-modal__close:hover,
.game-modal__close:focus-visible {
  border-color: #087f9c;
  color: #087f9c;
}

.game-modal__eyebrow {
  margin: 0 3.5rem 0.45rem 0;
  color: #087f9c;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.game-modal__title {
  margin: 0 3.5rem 1.5rem 0;
  font-size: clamp(1.5rem, 4vw, 2.25rem);
  text-align: left;
}

.video-preview {
  position: relative;
  display: grid;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 0.8rem;
  place-items: center;
  background:
    radial-gradient(circle at center, rgb(34 211 238 / 14%), transparent 35%),
    #08111f;
}

.video-preview iframe,
.video-preview__placeholder {
  width: 100%;
  height: 100%;
  border: 0;
}

.video-preview__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.9rem;
  color: #d4d4d8;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.video-preview__placeholder[hidden],
.video-preview iframe[hidden] {
  display: none;
}

.video-preview__play {
  display: grid;
  width: 4rem;
  height: 2.8rem;
  border-radius: 0.7rem;
  place-items: center;
  background: #ff0033;
  color: #ffffff;
  font-size: 1.2rem;
  text-indent: 0.15em;
}

.game-modal__label {
  display: block;
  margin: 1.5rem 0 0.55rem;
  color: #3f3f46;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.game-modal__description {
  display: block;
  width: 100%;
  min-height: 8rem;
  resize: vertical;
  padding: 1rem;
  border: 1px solid #d4d4d8;
  border-radius: 0.7rem;
  background: #fafafa;
  color: #3f3f46;
  font: inherit;
  font-size: 0.95rem;
  line-height: 1.65;
}

.game-modal__description:focus-visible {
  border-color: #087f9c;
  outline: 3px solid rgb(8 127 156 / 16%);
}

footer {
  width: min(100% - 2rem, 74rem);
  margin: 0 auto;
  padding: 2rem 0 2.5rem;
  border-top: 1px solid #e4e4e7;
  color: #71717a;
  font-size: 0.72rem;
  letter-spacing: 0.1em;
  text-align: center;
  text-transform: uppercase;
}

footer p {
  margin: 1.25rem 0 0;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem 1.5rem;
}

.footer-links a {
  color: #3f3f46;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-decoration: none;
}

.footer-links a:hover,
.footer-links a:focus-visible {
  color: #087f9c;
  text-decoration: underline;
  text-underline-offset: 0.3em;
}

.content-page {
  display: grid;
  place-items: start center;
  padding: clamp(2rem, 5vw, 3.5rem) 1rem clamp(3.5rem, 7vw, 5rem);
}

.subpage-header {
  display: flex;
  width: min(100% - 2rem, 74rem);
  min-height: 7rem;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border-bottom: 1px solid #e4e4e7;
}

.subpage-header a {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(60vw, 11.25rem);
  color: inherit;
  text-decoration: none;
}

.subpage-header img {
  display: block;
  width: 100%;
  height: auto;
}

.content-page__inner {
  width: min(100%, 46rem);
}

.content-page__inner h1 {
  margin: 0 0 0.65rem;
  font-family: "Orbitron", "Eurostile", sans-serif;
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  letter-spacing: -0.04em;
}

.content-page__inner .section-kicker {
  margin-bottom: 1.25rem;
  text-align: left;
}

.content-page__inner p {
  max-width: 42rem;
  margin: 0;
  color: #52525b;
  font-size: 1.05rem;
  line-height: 1.75;
}

.press-release {
  margin-top: 2.5rem;
  padding-top: 2rem;
  border-top: 1px solid #e4e4e7;
}

.press-release time {
  color: #52525b;
  font-size: 0.9rem;
}

.press-release h2 {
  margin: 0.5rem 0 1rem;
  font-size: clamp(1.25rem, 3vw, 1.55rem);
  line-height: 1.4;
  text-align: left;
}

.press-release p + p {
  margin-top: 1rem;
}

.press-release a {
  color: inherit;
  text-underline-offset: 0.2em;
}

.legal-page section {
  margin-top: 2.5rem;
  scroll-margin-top: 1.5rem;
}

.legal-page h2 {
  margin: 0 0 0.85rem;
  font-family: inherit;
  font-size: 1.25rem;
  line-height: 1.4;
  text-align: left;
}

.legal-page p + p {
  margin-top: 1rem;
}

.legal-page ul,
.legal-page ol {
  padding-left: 1.5rem;
  color: #52525b;
  font-size: 1.05rem;
  line-height: 1.75;
}

.legal-page li + li {
  margin-top: 0.5rem;
}

.legal-page a {
  color: #08728c;
  text-underline-offset: 0.2em;
  overflow-wrap: anywhere;
}

.legal-page a:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 4px;
}

.legal-page__contents {
  margin-top: 2rem;
  padding: 1.5rem;
  border: 1px solid #e4e4e7;
  border-radius: 0.75rem;
  background: #fafafa;
}

.legal-page__contents ol {
  margin-bottom: 0;
}

.privacy-policy p + p {
  margin-top: 1rem;
}

.privacy-policy h2 {
  margin: 2.5rem 0 1rem;
  font-family: inherit;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: -0.02em;
  text-align: left;
  scroll-margin-top: 1.5rem;
}

.privacy-policy ul {
  max-width: 42rem;
  padding-left: 1.4rem;
  color: #52525b;
  font-size: 1.05rem;
  line-height: 1.75;
}

.privacy-policy li + li {
  margin-top: 0.75rem;
}

.privacy-policy a {
  color: #08758f;
  overflow-wrap: anywhere;
  text-underline-offset: 0.2em;
}

.privacy-policy a:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 3px;
}

.privacy-policy__contents {
  margin-top: 2rem;
  padding: 1.25rem 1.5rem;
  border: 1px solid #e4e4e7;
  border-radius: 0.75rem;
  background: #fafafa;
}

.privacy-policy__contents ul {
  margin-bottom: 0;
}

.privacy-policy__contents li + li {
  margin-top: 0.25rem;
}

.game-intro {
  min-height: calc(100vh - 7rem);
  padding: clamp(2rem, 6vw, 5rem) 1rem;
  background:
    radial-gradient(circle at 15% 15%, rgb(255 202 73 / 25%), transparent 27rem),
    radial-gradient(circle at 88% 30%, rgb(20 174 177 / 25%), transparent 28rem),
    linear-gradient(155deg, #fff8e8 0%, #f7fbf6 52%, #e9f7f7 100%);
}

.game-intro__inner {
  display: grid;
  width: min(100%, 68rem);
  min-height: 34rem;
  align-items: center;
  gap: clamp(2rem, 6vw, 5rem);
  grid-template-columns: minmax(0, 1.1fr) minmax(18rem, 0.9fr);
  margin: 0 auto;
}

.game-intro__art {
  display: grid;
  place-items: center;
}

.game-intro__logo {
  display: block;
  width: min(100%, 36rem);
  height: auto;
  filter: drop-shadow(0 1.5rem 1.6rem rgb(0 55 62 / 24%));
}

.game-intro__copy {
  padding: clamp(1.5rem, 4vw, 2.5rem);
  border: 1px solid rgb(255 255 255 / 70%);
  border-radius: 1.5rem;
  background: rgb(255 255 255 / 72%);
  box-shadow: 0 1.5rem 4rem rgb(0 68 75 / 13%);
  backdrop-filter: blur(14px);
}

.game-intro__copy .section-kicker {
  margin-bottom: 1rem;
  color: #087f79;
  text-align: left;
}

.game-intro__copy h1 {
  margin: 0 0 1rem;
  font-family: "Orbitron", "Eurostile", sans-serif;
  font-size: clamp(2rem, 5vw, 3.75rem);
  line-height: 1.05;
  letter-spacing: -0.055em;
}

.game-intro__copy p {
  margin: 0;
  color: #3f4d4b;
  font-size: clamp(1rem, 2vw, 1.15rem);
  line-height: 1.75;
}

.game-intro__status {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  margin: 1.5rem 0 0;
  color: #9f3d28;
  font-family: "Orbitron", monospace;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.game-intro__status::before {
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
  background: #ff9d41;
  box-shadow: 0 0 0 0.3rem rgb(255 157 65 / 18%);
  content: "";
}

.game-intro__back {
  display: inline-flex;
  margin-top: 2rem;
  color: #087f79;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-decoration: none;
  text-transform: uppercase;
}

.game-intro__back:hover,
.game-intro__back:focus-visible {
  color: #9f3d28;
  text-decoration: underline;
  text-underline-offset: 0.35em;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

@media (max-width: 720px) {
  .game-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .game-card {
    min-height: 13rem;
  }

  .game-intro__inner {
    grid-template-columns: 1fr;
  }

  .game-intro__art {
    order: -1;
  }
}

@media (max-width: 460px) {
  .site-shell {
    width: min(100% - 1.25rem, 74rem);
  }

  .hero {
    min-height: 16rem;
    padding-top: 1rem;
  }

  .game-grid {
    grid-template-columns: 1fr;
  }

  .game-card {
    min-height: 16rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }

  .game-card,
  .game-card::after {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB;0BACwB;EACxB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,+DAA+D;EAC/D,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,+DAA+D;EAC/D,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB;;;WAGS;EACT,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB;;;yBAGuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,eAAe;EACf,+CAA+C;EAC/C,yCAAyC;EACzC;;gDAE8C;AAChD;;AAEA;EACE,QAAQ;EACR,4FAA4F;EAC5F,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,sDAAsD;EACtD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kCAAkC;EAClC,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;;;;WAIS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B;;6CAE2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB;;6CAE2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B;;6CAE2C;AAC7C;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B;;6CAE2C;AAC7C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB;;6CAE2C;AAC7C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;;;WAGS;AACX;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gDAAgD;EAChD,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB;;WAES;AACX;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;EAChD,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC;;;kEAGgE;AAClE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,qBAAqB;EACrB,kCAAkC;EAClC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,oCAAoC;EACpC,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":[":root {\n  color-scheme: light;\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,\n    \"Segoe UI\", sans-serif;\n  color: #18181b;\n  background: #ffffff;\n  font-synthesis: none;\n  text-rendering: optimizeLegibility;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  position: relative;\n  min-width: 320px;\n  min-height: 100vh;\n  margin: 0;\n  overflow-x: hidden;\n  background: #ffffff;\n}\n\nbody::before {\n  content: none;\n}\n\n.background-glow {\n  display: none;\n}\n\n.background-glow--one {\n  top: -19rem;\n  left: -12rem;\n  background: #00d9ff;\n}\n\n.background-glow--two {\n  right: -15rem;\n  bottom: 2rem;\n  background: #3669ff;\n}\n\n.site-shell {\n  width: min(100% - 2rem, 74rem);\n  margin-inline: auto;\n}\n\n.hero {\n  display: grid;\n  min-height: clamp(16rem, 38vh, 24rem);\n  place-items: center;\n  padding: 2rem 0 3rem;\n}\n\n.brand-lockup {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.logo-halo {\n  position: relative;\n  display: grid;\n  width: min(70vw, 15rem);\n  aspect-ratio: 1;\n  place-items: center;\n}\n\n.logo-halo::before {\n  content: none;\n}\n\n.studio-logo {\n  position: relative;\n  z-index: 1;\n  display: block;\n  width: 100%;\n  height: auto;\n  filter: drop-shadow(0 1.25rem 1.75rem rgb(0 20 52 / 28%));\n}\n\n.brand-slogan {\n  margin: 0.65rem 0 0;\n  color: #3f3f46;\n  font-family: \"Orbitron\", \"Eurostile\", \"Bank Gothic\", sans-serif;\n  font-size: clamp(0.68rem, 1.5vw, 0.8rem);\n  font-weight: 600;\n  line-height: 1.4;\n  letter-spacing: 0.08em;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.games {\n  border-top: 1px solid #e4e4e7;\n  padding: 3rem 0 clamp(5rem, 10vw, 8rem);\n}\n\n.section-kicker {\n  margin: 0 0 0.8rem;\n  color: #087f9c;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-align: center;\n  text-transform: uppercase;\n}\n\nh2 {\n  margin: 0 0 clamp(2rem, 5vw, 4rem);\n  font-family: \"Orbitron\", \"Eurostile\", \"Bank Gothic\", sans-serif;\n  font-size: clamp(1.75rem, 4vw, 3.25rem);\n  font-weight: 600;\n  line-height: 1;\n  letter-spacing: -0.045em;\n  text-align: center;\n  text-shadow: none;\n}\n\n.game-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: clamp(0.8rem, 2vw, 1.3rem);\n}\n\n.game-card {\n  --card-accent: 56 214 255;\n  position: relative;\n  display: flex;\n  min-height: clamp(12rem, 24vw, 18rem);\n  overflow: hidden;\n  align-items: flex-end;\n  width: 100%;\n  padding: clamp(1.1rem, 2.5vw, 1.6rem);\n  border: 1px solid rgb(255 255 255 / 11%);\n  border-radius: 1rem;\n  isolation: isolate;\n  background:\n    linear-gradient(145deg, rgb(var(--card-accent) / 18%), transparent 42%),\n    linear-gradient(to top, rgb(3 10 23 / 96%), rgb(9 23 43 / 34%)),\n    #0c182a;\n  box-shadow: 0 1.2rem 3rem rgb(0 0 0 / 18%);\n  color: #eef8ff;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n  text-decoration: none;\n  transition:\n    border-color 180ms ease,\n    transform 180ms ease,\n    box-shadow 180ms ease;\n}\n\n.game-card::before,\n.game-card::after {\n  position: absolute;\n  z-index: -1;\n  content: \"\";\n}\n\n.game-card::before {\n  top: 18%;\n  left: 50%;\n  width: 46%;\n  aspect-ratio: 1;\n  border: 1px solid rgb(var(--card-accent) / 48%);\n  transform: translateX(-50%) rotate(45deg);\n  box-shadow:\n    0 0 2rem rgb(var(--card-accent) / 20%),\n    inset 0 0 2rem rgb(var(--card-accent) / 10%);\n}\n\n.game-card::after {\n  inset: 0;\n  background: linear-gradient(120deg, transparent 35%, rgb(255 255 255 / 5%), transparent 65%);\n  transform: translateX(-100%);\n  transition: transform 450ms ease;\n}\n\n.game-card:hover {\n  border-color: rgb(var(--card-accent) / 55%);\n  box-shadow: 0 1.8rem 4rem rgb(0 0 0 / 30%);\n  transform: translateY(-0.35rem);\n}\n\n.game-card:hover::after {\n  transform: translateX(100%);\n}\n\n.game-card:focus-visible {\n  border-color: rgb(var(--card-accent) / 85%);\n  outline: 3px solid rgb(var(--card-accent) / 38%);\n  outline-offset: 3px;\n}\n\n.game-card--two,\n.game-card--eight {\n  --card-accent: 114 125 255;\n}\n\n.game-card--three,\n.game-card--seven {\n  --card-accent: 50 237 199;\n}\n\n.game-card--four,\n.game-card--nine {\n  --card-accent: 176 116 255;\n}\n\n.game-card--ten {\n  --card-accent: 212 175 55;\n}\n\n.game-card--eleven {\n  --card-accent: 72 184 255;\n}\n\n.game-card--twelve {\n  --card-accent: 114 125 255;\n}\n\n.game-card--thirteen {\n  --card-accent: 50 237 199;\n}\n\n.game-card--fourteen {\n  --card-accent: 176 116 255;\n}\n\n.game-card--fifteen {\n  --card-accent: 255 184 77;\n}\n\n.game-card--sixteen {\n  --card-accent: 255 102 24;\n}\n\n.game-card--five {\n  --card-accent: 255 184 77;\n}\n\n.game-card--six {\n  --card-accent: 255 104 152;\n}\n\n.game-date {\n  position: absolute;\n  top: 1rem;\n  right: 1.1rem;\n  color: #d4af37;\n  font-family: \"Orbitron\", monospace;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-shadow: 0 0 1rem rgb(212 175 55 / 30%);\n}\n\n.game-card__multiplayer {\n  position: absolute;\n  z-index: 2;\n  top: clamp(0.65rem, 1.5vw, 0.9rem);\n  left: clamp(0.7rem, 1.5vw, 1rem);\n  width: clamp(6.25rem, 11vw, 7.75rem);\n  aspect-ratio: 4.9 / 1;\n  object-fit: cover;\n  object-position: center;\n  filter: drop-shadow(0 0.2rem 0.35rem rgb(0 0 0 / 55%));\n  pointer-events: none;\n}\n\n.game-card__content {\n  position: relative;\n  z-index: 1;\n}\n\n.game-card--featured {\n  align-items: stretch;\n}\n\n.game-card__content--featured {\n  display: flex;\n  min-height: 100%;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-top: 1.25rem;\n  text-align: center;\n}\n\n.game-card__logo {\n  display: block;\n  width: 100%;\n  height: clamp(6rem, 12vw, 8.75rem);\n  object-fit: contain;\n  filter: drop-shadow(0 0.75rem 1rem rgb(0 0 0 / 38%));\n}\n\n.game-card--ghosts .game-card__logo {\n  width: min(72%, 10rem);\n  height: clamp(7.5rem, 14vw, 10rem);\n}\n\n.game-card--small-town {\n  --card-accent: 255 157 65;\n  background:\n    radial-gradient(circle at 50% 20%, rgb(255 204 88 / 23%), transparent 35%),\n    linear-gradient(145deg, rgb(20 174 177 / 24%), transparent 48%),\n    linear-gradient(to top, rgb(3 30 42 / 98%), rgb(14 71 80 / 78%)),\n    #07333d;\n}\n\n.game-card--small-town .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--lazy-lunch-lady {\n  --card-accent: 239 65 54;\n  background:\n    radial-gradient(circle at 50% 18%, rgb(255 193 69 / 22%), transparent 36%),\n    linear-gradient(145deg, rgb(21 118 110 / 30%), transparent 50%),\n    linear-gradient(to top, rgb(40 10 13 / 98%), rgb(8 55 58 / 82%)),\n    #123f40;\n}\n\n.game-card--lazy-lunch-lady .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--bedbug-bash {\n  --card-accent: 255 85 42;\n  background:\n    radial-gradient(circle at 50% 20%, rgb(255 205 50 / 24%), transparent 36%),\n    linear-gradient(145deg, rgb(180 35 24 / 28%), transparent 50%),\n    linear-gradient(to top, rgb(43 9 6 / 98%), rgb(91 28 15 / 82%)),\n    #35100a;\n}\n\n.game-card--bedbug-bash .game-card__logo {\n  height: clamp(7rem, 14vw, 10rem);\n}\n\n.game-card--poop-racer {\n  --card-accent: 24 201 204;\n  background:\n    radial-gradient(circle at 50% 18%, rgb(249 218 38 / 20%), transparent 36%),\n    linear-gradient(145deg, rgb(20 198 198 / 30%), transparent 50%),\n    linear-gradient(to top, rgb(31 14 6 / 98%), rgb(5 61 66 / 86%)),\n    #07383b;\n}\n\n.game-card--poop-racer .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--cafe-nervosa {\n  --card-accent: 247 191 50;\n  background:\n    radial-gradient(circle at 50% 20%, rgb(23 178 176 / 24%), transparent 38%),\n    linear-gradient(145deg, rgb(219 48 35 / 28%), transparent 52%),\n    linear-gradient(to top, rgb(29 10 5 / 98%), rgb(77 27 13 / 84%)),\n    #2c110b;\n}\n\n.game-card--cafe-nervosa .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--lost-tribes {\n  background:\n    radial-gradient(circle at 50% 18%, rgb(212 175 55 / 24%), transparent 38%),\n    linear-gradient(145deg, rgb(14 75 105 / 34%), transparent 52%),\n    linear-gradient(to top, rgb(12 8 4 / 98%), rgb(7 30 44 / 88%)),\n    #071923;\n}\n\n.game-card--lost-tribes .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--frost-fighter {\n  background:\n    radial-gradient(circle at 50% 18%, rgb(137 255 101 / 19%), transparent 36%),\n    linear-gradient(145deg, rgb(65 201 255 / 27%), transparent 50%),\n    linear-gradient(to top, rgb(2 20 41 / 98%), rgb(5 50 79 / 86%)),\n    #062943;\n}\n\n.game-card--frost-fighter .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--trash-or-treasure {\n  --card-accent: 234 183 50;\n  background:\n    radial-gradient(circle at 50% 18%, rgb(255 211 67 / 24%), transparent 36%),\n    linear-gradient(145deg, rgb(92 133 48 / 30%), transparent 50%),\n    linear-gradient(to top, rgb(24 14 7 / 98%), rgb(48 60 26 / 86%)),\n    #252714;\n}\n\n.game-card--trash-or-treasure .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--poison-pickle {\n  --card-accent: 166 255 0;\n  background:\n    radial-gradient(circle at 50% 18%, rgb(172 255 47 / 25%), transparent 38%),\n    linear-gradient(145deg, rgb(151 28 255 / 30%), transparent 52%),\n    linear-gradient(to top, rgb(17 3 27 / 98%), rgb(27 49 8 / 88%)),\n    #13051d;\n}\n\n.game-card--poison-pickle .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--c-suite-simulator {\n  --card-accent: 32 211 170;\n  background:\n    radial-gradient(circle at 50% 18%, rgb(255 165 45 / 24%), transparent 38%),\n    linear-gradient(145deg, rgb(13 154 151 / 32%), transparent 52%),\n    linear-gradient(to top, rgb(21 8 4 / 98%), rgb(4 47 49 / 88%)),\n    #062b2d;\n}\n\n.game-card--c-suite-simulator .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--escape-from-seattle {\n  --card-accent: 189 54 32;\n  background:\n    radial-gradient(circle at 50% 18%, rgb(216 92 45 / 22%), transparent 38%),\n    linear-gradient(145deg, rgb(73 83 60 / 28%), transparent 52%),\n    linear-gradient(to top, rgb(10 8 7 / 98%), rgb(37 42 34 / 90%)),\n    #12130f;\n}\n\n.game-card--escape-from-seattle .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--woke-trash-battle-chess {\n  background:\n    radial-gradient(circle at 50% 20%, rgb(255 102 24 / 26%), transparent 42%),\n    linear-gradient(145deg, rgb(246 224 181 / 12%), transparent 52%),\n    linear-gradient(to top, rgb(10 8 7 / 98%), rgb(34 23 17 / 90%)),\n    #17110d;\n}\n\n.game-card--woke-trash-battle-chess .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--waifu-wants-waffles {\n  --card-accent: 255 145 182;\n  background:\n    radial-gradient(circle at 50% 22%, rgb(255 183 93 / 24%), transparent 48%),\n    linear-gradient(to top, #201019, #472737);\n}\n\n.game-card--communist-comrades {\n  --card-accent: 207 84 245;\n  background:\n    radial-gradient(circle at 50% 22%, rgb(225 64 131 / 25%), transparent 48%),\n    linear-gradient(to top, #1c0d20, #392039);\n}\n\n.game-card--witch-race-derby {\n  --card-accent: 195 125 255;\n  background:\n    radial-gradient(circle at 50% 22%, rgb(255 202 88 / 22%), transparent 48%),\n    linear-gradient(to top, #180d2c, #44265c);\n}\n\n.game-card--witch-race-derby .game-card__logo,\n.game-card--waifu-wants-waffles .game-card__logo,\n.game-card--communist-comrades .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--breeders {\n  --card-accent: 167 224 116;\n  background:\n    radial-gradient(circle at 50% 22%, rgb(181 151 229 / 22%), transparent 48%),\n    linear-gradient(to top, #101e18, #2b3e2d);\n}\n\n.game-card--breeders .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--sandwich-maker-puzzle {\n  --card-accent: 255 190 83;\n  background:\n    radial-gradient(circle at 50% 22%, rgb(255 169 52 / 24%), transparent 48%),\n    linear-gradient(to top, #211008, #4a2912);\n}\n\n.game-card--sandwich-maker-puzzle .game-card__logo {\n  height: clamp(8rem, 15vw, 11rem);\n}\n\n.game-card--placeholder {\n  background:\n    linear-gradient(145deg, rgb(var(--card-accent) / 13%), transparent 48%),\n    linear-gradient(to top, rgb(3 10 23 / 98%), rgb(18 31 50 / 72%)),\n    #0c182a;\n}\n\n.game-card--placeholder::before {\n  border-style: dashed;\n  opacity: 0.55;\n}\n\n.game-card--placeholder .game-card__content {\n  margin: auto 0;\n}\n\n.game-card h3 {\n  margin: 0;\n  font-family: \"Orbitron\", \"Eurostile\", sans-serif;\n  font-size: clamp(0.9rem, 2vw, 1.1rem);\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n\n.game-card p {\n  margin: 0.4rem 0 0;\n  color: rgb(211 238 249 / 62%);\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n}\n\n.game-card p.game-card__subtitle {\n  max-width: 29rem;\n  margin-top: 0.8rem;\n  color: rgb(238 248 255 / 78%);\n  font-size: clamp(0.55rem, 1.1vw, 0.67rem);\n  line-height: 1.5;\n  letter-spacing: 0.07em;\n  text-transform: none;\n}\n\n.modal-open {\n  overflow: hidden;\n}\n\n.game-modal {\n  width: min(92vw, 52rem);\n  max-height: 92vh;\n  overflow: auto;\n  padding: 0;\n  border: 0;\n  border-radius: 1.25rem;\n  background: #ffffff;\n  box-shadow: 0 2rem 6rem rgb(0 0 0 / 38%);\n}\n\n.game-modal::backdrop {\n  background: rgb(3 10 23 / 76%);\n  backdrop-filter: blur(6px);\n}\n\n.game-modal__panel {\n  position: relative;\n  padding: clamp(1.25rem, 4vw, 2.5rem);\n}\n\n.game-modal__close {\n  position: absolute;\n  z-index: 1;\n  top: 1rem;\n  right: 1rem;\n  display: grid;\n  width: 2.5rem;\n  height: 2.5rem;\n  padding: 0;\n  border: 1px solid #d4d4d8;\n  border-radius: 50%;\n  place-items: center;\n  background: #ffffff;\n  color: #27272a;\n  cursor: pointer;\n  font-size: 1.65rem;\n  line-height: 1;\n}\n\n.game-modal__close:hover,\n.game-modal__close:focus-visible {\n  border-color: #087f9c;\n  color: #087f9c;\n}\n\n.game-modal__eyebrow {\n  margin: 0 3.5rem 0.45rem 0;\n  color: #087f9c;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n}\n\n.game-modal__title {\n  margin: 0 3.5rem 1.5rem 0;\n  font-size: clamp(1.5rem, 4vw, 2.25rem);\n  text-align: left;\n}\n\n.video-preview {\n  position: relative;\n  display: grid;\n  overflow: hidden;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  border-radius: 0.8rem;\n  place-items: center;\n  background:\n    radial-gradient(circle at center, rgb(34 211 238 / 14%), transparent 35%),\n    #08111f;\n}\n\n.video-preview iframe,\n.video-preview__placeholder {\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.video-preview__placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.9rem;\n  color: #d4d4d8;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.video-preview__placeholder[hidden],\n.video-preview iframe[hidden] {\n  display: none;\n}\n\n.video-preview__play {\n  display: grid;\n  width: 4rem;\n  height: 2.8rem;\n  border-radius: 0.7rem;\n  place-items: center;\n  background: #ff0033;\n  color: #ffffff;\n  font-size: 1.2rem;\n  text-indent: 0.15em;\n}\n\n.game-modal__label {\n  display: block;\n  margin: 1.5rem 0 0.55rem;\n  color: #3f3f46;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n}\n\n.game-modal__description {\n  display: block;\n  width: 100%;\n  min-height: 8rem;\n  resize: vertical;\n  padding: 1rem;\n  border: 1px solid #d4d4d8;\n  border-radius: 0.7rem;\n  background: #fafafa;\n  color: #3f3f46;\n  font: inherit;\n  font-size: 0.95rem;\n  line-height: 1.65;\n}\n\n.game-modal__description:focus-visible {\n  border-color: #087f9c;\n  outline: 3px solid rgb(8 127 156 / 16%);\n}\n\nfooter {\n  width: min(100% - 2rem, 74rem);\n  margin: 0 auto;\n  padding: 2rem 0 2.5rem;\n  border-top: 1px solid #e4e4e7;\n  color: #71717a;\n  font-size: 0.72rem;\n  letter-spacing: 0.1em;\n  text-align: center;\n  text-transform: uppercase;\n}\n\nfooter p {\n  margin: 1.25rem 0 0;\n}\n\n.footer-links {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.75rem 1.5rem;\n}\n\n.footer-links a {\n  color: #3f3f46;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-decoration: none;\n}\n\n.footer-links a:hover,\n.footer-links a:focus-visible {\n  color: #087f9c;\n  text-decoration: underline;\n  text-underline-offset: 0.3em;\n}\n\n.content-page {\n  display: grid;\n  place-items: start center;\n  padding: clamp(2rem, 5vw, 3.5rem) 1rem clamp(3.5rem, 7vw, 5rem);\n}\n\n.subpage-header {\n  display: flex;\n  width: min(100% - 2rem, 74rem);\n  min-height: 7rem;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.subpage-header a {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: min(60vw, 11.25rem);\n  color: inherit;\n  text-decoration: none;\n}\n\n.subpage-header img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.content-page__inner {\n  width: min(100%, 46rem);\n}\n\n.content-page__inner h1 {\n  margin: 0 0 0.65rem;\n  font-family: \"Orbitron\", \"Eurostile\", sans-serif;\n  font-size: clamp(1.75rem, 4vw, 2.5rem);\n  letter-spacing: -0.04em;\n}\n\n.content-page__inner .section-kicker {\n  margin-bottom: 1.25rem;\n  text-align: left;\n}\n\n.content-page__inner p {\n  max-width: 42rem;\n  margin: 0;\n  color: #52525b;\n  font-size: 1.05rem;\n  line-height: 1.75;\n}\n\n.press-release {\n  margin-top: 2.5rem;\n  padding-top: 2rem;\n  border-top: 1px solid #e4e4e7;\n}\n\n.press-release time {\n  color: #52525b;\n  font-size: 0.9rem;\n}\n\n.press-release h2 {\n  margin: 0.5rem 0 1rem;\n  font-size: clamp(1.25rem, 3vw, 1.55rem);\n  line-height: 1.4;\n  text-align: left;\n}\n\n.press-release p + p {\n  margin-top: 1rem;\n}\n\n.press-release a {\n  color: inherit;\n  text-underline-offset: 0.2em;\n}\n\n.legal-page section {\n  margin-top: 2.5rem;\n  scroll-margin-top: 1.5rem;\n}\n\n.legal-page h2 {\n  margin: 0 0 0.85rem;\n  font-family: inherit;\n  font-size: 1.25rem;\n  line-height: 1.4;\n  text-align: left;\n}\n\n.legal-page p + p {\n  margin-top: 1rem;\n}\n\n.legal-page ul,\n.legal-page ol {\n  padding-left: 1.5rem;\n  color: #52525b;\n  font-size: 1.05rem;\n  line-height: 1.75;\n}\n\n.legal-page li + li {\n  margin-top: 0.5rem;\n}\n\n.legal-page a {\n  color: #08728c;\n  text-underline-offset: 0.2em;\n  overflow-wrap: anywhere;\n}\n\n.legal-page a:focus-visible {\n  outline: 2px solid currentColor;\n  outline-offset: 4px;\n}\n\n.legal-page__contents {\n  margin-top: 2rem;\n  padding: 1.5rem;\n  border: 1px solid #e4e4e7;\n  border-radius: 0.75rem;\n  background: #fafafa;\n}\n\n.legal-page__contents ol {\n  margin-bottom: 0;\n}\n\n.privacy-policy p + p {\n  margin-top: 1rem;\n}\n\n.privacy-policy h2 {\n  margin: 2.5rem 0 1rem;\n  font-family: inherit;\n  font-size: 1.35rem;\n  font-weight: 700;\n  line-height: 1.4;\n  letter-spacing: -0.02em;\n  text-align: left;\n  scroll-margin-top: 1.5rem;\n}\n\n.privacy-policy ul {\n  max-width: 42rem;\n  padding-left: 1.4rem;\n  color: #52525b;\n  font-size: 1.05rem;\n  line-height: 1.75;\n}\n\n.privacy-policy li + li {\n  margin-top: 0.75rem;\n}\n\n.privacy-policy a {\n  color: #08758f;\n  overflow-wrap: anywhere;\n  text-underline-offset: 0.2em;\n}\n\n.privacy-policy a:focus-visible {\n  outline: 2px solid currentColor;\n  outline-offset: 3px;\n}\n\n.privacy-policy__contents {\n  margin-top: 2rem;\n  padding: 1.25rem 1.5rem;\n  border: 1px solid #e4e4e7;\n  border-radius: 0.75rem;\n  background: #fafafa;\n}\n\n.privacy-policy__contents ul {\n  margin-bottom: 0;\n}\n\n.privacy-policy__contents li + li {\n  margin-top: 0.25rem;\n}\n\n.game-intro {\n  min-height: calc(100vh - 7rem);\n  padding: clamp(2rem, 6vw, 5rem) 1rem;\n  background:\n    radial-gradient(circle at 15% 15%, rgb(255 202 73 / 25%), transparent 27rem),\n    radial-gradient(circle at 88% 30%, rgb(20 174 177 / 25%), transparent 28rem),\n    linear-gradient(155deg, #fff8e8 0%, #f7fbf6 52%, #e9f7f7 100%);\n}\n\n.game-intro__inner {\n  display: grid;\n  width: min(100%, 68rem);\n  min-height: 34rem;\n  align-items: center;\n  gap: clamp(2rem, 6vw, 5rem);\n  grid-template-columns: minmax(0, 1.1fr) minmax(18rem, 0.9fr);\n  margin: 0 auto;\n}\n\n.game-intro__art {\n  display: grid;\n  place-items: center;\n}\n\n.game-intro__logo {\n  display: block;\n  width: min(100%, 36rem);\n  height: auto;\n  filter: drop-shadow(0 1.5rem 1.6rem rgb(0 55 62 / 24%));\n}\n\n.game-intro__copy {\n  padding: clamp(1.5rem, 4vw, 2.5rem);\n  border: 1px solid rgb(255 255 255 / 70%);\n  border-radius: 1.5rem;\n  background: rgb(255 255 255 / 72%);\n  box-shadow: 0 1.5rem 4rem rgb(0 68 75 / 13%);\n  backdrop-filter: blur(14px);\n}\n\n.game-intro__copy .section-kicker {\n  margin-bottom: 1rem;\n  color: #087f79;\n  text-align: left;\n}\n\n.game-intro__copy h1 {\n  margin: 0 0 1rem;\n  font-family: \"Orbitron\", \"Eurostile\", sans-serif;\n  font-size: clamp(2rem, 5vw, 3.75rem);\n  line-height: 1.05;\n  letter-spacing: -0.055em;\n}\n\n.game-intro__copy p {\n  margin: 0;\n  color: #3f4d4b;\n  font-size: clamp(1rem, 2vw, 1.15rem);\n  line-height: 1.75;\n}\n\n.game-intro__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n  margin: 1.5rem 0 0;\n  color: #9f3d28;\n  font-family: \"Orbitron\", monospace;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.game-intro__status::before {\n  width: 0.55rem;\n  height: 0.55rem;\n  border-radius: 50%;\n  background: #ff9d41;\n  box-shadow: 0 0 0 0.3rem rgb(255 157 65 / 18%);\n  content: \"\";\n}\n\n.game-intro__back {\n  display: inline-flex;\n  margin-top: 2rem;\n  color: #087f79;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-decoration: none;\n  text-transform: uppercase;\n}\n\n.game-intro__back:hover,\n.game-intro__back:focus-visible {\n  color: #9f3d28;\n  text-decoration: underline;\n  text-underline-offset: 0.35em;\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  border: 0;\n  margin: -1px;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n\n@media (max-width: 720px) {\n  .game-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .game-card {\n    min-height: 13rem;\n  }\n\n  .game-intro__inner {\n    grid-template-columns: 1fr;\n  }\n\n  .game-intro__art {\n    order: -1;\n  }\n}\n\n@media (max-width: 460px) {\n  .site-shell {\n    width: min(100% - 1.25rem, 74rem);\n  }\n\n  .hero {\n    min-height: 16rem;\n    padding-top: 1rem;\n  }\n\n  .game-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .game-card {\n    min-height: 16rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n\n  .game-card,\n  .game-card::after {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
